var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel-with-pages"},[_c('div',{staticClass:"dot-container"},_vm._l((_vm.routes),function(route,index){return _c('span',{key:index,class:{ active: _vm.currentRoute === route.path },on:{"click":function($event){return _vm.handleClick(route.path)}}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }